import { ChallengeEditor } from '@/components/challenges/editor/ChallengeEditor';
import { useParams, useSearchParams } from 'react-router-dom';

/**
 * Event challenge create/edit page — a thin wrapper around the unified
 * `<ChallengeEditor>`. Mounted at `/events/:id/challenges/new` (create,
 * with an optional `?groupId=` pre-selection) and
 * `/events/:id/challenges/:challengeId/edit` (edit).
 */
export function EventChallengeFormPage() {
  const { id: eventId, challengeId } = useParams<{ id: string; challengeId?: string }>();
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get('groupId');

  return (
    <ChallengeEditor
      context="event"
      eventId={eventId}
      challengeId={challengeId}
      groupId={groupId}
    />
  );
}
